"use client";

import { useEffect } from "react";
import {
  DEFAULT_FONT_FAMILY,
  DEFAULT_PRIMARY_COLOR,
  DEFAULT_SECONDARY_COLOR,
  getTenantFontCssValue,
  normalizeTenantFontFamily,
} from "@/lib/tenant-branding";

function isHexColor(value: string | null): value is string {
  return Boolean(value && /^#([0-9a-fA-F]{6})$/.test(value));
}

export default function TenantBrandingBootstrap({
  initialPrimaryColor,
  initialSecondaryColor,
  initialFontFamily,
}: {
  initialPrimaryColor?: string | null;
  initialSecondaryColor?: string | null;
  initialFontFamily?: string | null;
}) {
  useEffect(() => {
    const primaryInput = initialPrimaryColor ?? null;
    const secondaryInput = initialSecondaryColor ?? null;
    const fontInput = initialFontFamily ?? null;
    const primary = isHexColor(primaryInput)
      ? primaryInput
      : DEFAULT_PRIMARY_COLOR;
    const secondary = isHexColor(secondaryInput)
      ? secondaryInput
      : DEFAULT_SECONDARY_COLOR;
    const fontFamily = normalizeTenantFontFamily(fontInput);

    document.cookie = `tenant_primary_color=${encodeURIComponent(primary)}; path=/`;
    document.cookie = `tenant_secondary_color=${encodeURIComponent(secondary)}; path=/`;
    document.cookie = `tenant_font_family=${encodeURIComponent(fontFamily)}; path=/`;

    document.documentElement.style.setProperty(
      "--tenant-primary-button",
      isHexColor(primary) ? primary : DEFAULT_PRIMARY_COLOR
    );
    document.documentElement.style.setProperty(
      "--tenant-secondary-button",
      isHexColor(secondary) ? secondary : DEFAULT_SECONDARY_COLOR
    );
    document.documentElement.style.setProperty(
      "--tenant-font-family",
      getTenantFontCssValue(fontFamily || DEFAULT_FONT_FAMILY)
    );
  }, [initialFontFamily, initialPrimaryColor, initialSecondaryColor]);

  return null;
}
